var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _circle, _circle2, _circle3, _path12, _path13, _path14, _mask, _path15, _circle4, _circle5, _path16, _path17, _path18, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _path19, _path20, _path21, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUplGenieLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 327,
    height: 72,
    viewBox: "0 0 327 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M132.445 16.25V34.0439C132.445 35.9955 132.955 37.4879 133.976 38.5084C134.996 39.5288 136.425 40.0518 138.262 40.0518C140.098 40.0518 141.565 39.5416 142.586 38.5084C143.606 37.4752 144.104 35.9828 144.104 34.0439V16.25H149.907V34.0057C149.907 36.4547 149.372 38.5211 148.326 40.2048C147.28 41.8886 145.851 43.1641 144.078 44.0187C142.305 44.8734 140.341 45.2943 138.172 45.2943C136.004 45.2943 134.09 44.8734 132.343 44.0187C130.595 43.1641 129.218 41.9013 128.197 40.2048C127.177 38.5211 126.667 36.4547 126.667 34.0057V16.25H132.432H132.445Z",
    fill: "#F87609"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M175.354 29.4779C174.627 30.83 173.492 31.9142 171.936 32.7305C170.38 33.5597 168.428 33.9678 166.068 33.9678H161.247V45.0141H155.481V16.2632H166.068C168.288 16.2632 170.188 16.6458 171.757 17.4112C173.326 18.1765 174.5 19.2352 175.278 20.5873C176.056 21.9394 176.451 23.4573 176.451 25.1538C176.451 26.6972 176.081 28.1386 175.354 29.4779ZM169.359 28.2278C170.125 27.5008 170.507 26.4803 170.507 25.1538C170.507 22.3476 168.938 20.9572 165.813 20.9572H161.234V29.3248H165.813C167.408 29.3248 168.581 28.9549 169.359 28.2278Z",
    fill: "#F87609"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M186.286 40.4344H195.764V45.0009H180.521V16.25H186.286V40.4344Z",
    fill: "#F87609"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M233.583 33.7631C233.583 26.6073 238.826 21.3647 246.262 21.3647C253.699 21.3647 258.852 26.6073 258.852 33.7631V35.7657H239.54C240.306 39.1969 242.921 41.0082 246.262 41.0082C248.788 41.0082 250.65 40.2939 251.837 38.7633H257.896C256.135 43.2404 251.837 46.1487 246.262 46.1487C238.826 46.1487 233.583 40.9062 233.583 33.7503V33.7631ZM252.857 31.2375C251.951 28.0869 249.375 26.518 246.275 26.518C243.176 26.518 240.599 28.1379 239.693 31.2375H252.857Z",
    fill: "#0073CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M262.577 33.2789C262.577 25.4088 267.245 21.3525 274.21 21.3525C281.174 21.3525 285.843 25.3578 285.843 33.2789V45.537H280.167V33.2789C280.167 28.8018 277.781 26.6461 274.21 26.6461C270.638 26.6461 268.253 28.789 268.253 33.2789V45.537H262.577V33.2789Z",
    fill: "#0073CB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M290.422 15.1659C290.422 12.972 291.991 11.3521 294.185 11.3521C296.379 11.3521 297.948 12.972 297.948 15.1659C297.948 17.3599 296.379 18.9288 294.185 18.9288C291.991 18.9288 290.422 17.3599 290.422 15.1659ZM291.328 21.9774H297.004V45.5368H291.328V21.9774Z",
    fill: "#0073CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M301.532 33.7631C301.532 26.6073 306.775 21.3647 314.211 21.3647C321.648 21.3647 326.801 26.6073 326.801 33.7631V35.7657H307.489C308.254 39.1969 310.869 41.0082 314.211 41.0082C316.737 41.0082 318.599 40.2939 319.785 38.7633H325.844C324.084 43.2404 319.785 46.1487 314.211 46.1487C306.775 46.1487 301.532 40.9062 301.532 33.7503V33.7631ZM320.806 31.2375C319.9 28.0869 317.324 26.518 314.224 26.518C311.124 26.518 308.548 28.1379 307.642 31.2375H320.806Z",
    fill: "#0073CB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M231.186 20.3577C233.2 20.3577 234.834 18.7244 234.834 16.7096C234.834 14.6948 233.2 13.0615 231.186 13.0615C229.171 13.0615 227.538 14.6948 227.538 16.7096C227.538 18.7244 229.171 20.3577 231.186 20.3577Z",
    fill: "#0073CB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M217.358 46.315C210.343 46.315 204.628 40.6005 204.628 33.585C204.628 26.5694 210.343 20.855 217.358 20.855C224.374 20.855 230.088 26.5694 230.088 33.585C230.088 40.6005 224.374 46.315 217.358 46.315ZM217.358 25.9572C213.149 25.9572 209.731 29.3757 209.731 33.585C209.731 37.7943 213.149 41.2128 217.358 41.2128C221.568 41.2128 224.986 37.7943 224.986 33.585C224.986 29.3757 221.568 25.9572 217.358 25.9572Z",
    fill: "#0073CB"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M217.358 60.6138C210.343 60.6138 204.628 54.8993 204.628 47.8838H209.731C209.731 52.0931 213.149 55.5116 217.358 55.5116C221.568 55.5116 224.986 52.0931 224.986 47.8838H230.088C230.088 54.8993 224.374 60.6138 217.358 60.6138Z",
    fill: "#0073CB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7376 30.5512L75.2793 30.4673",
    stroke: "#0073CB",
    strokeWidth: 2.72777
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.36444,
    cy: 4.36444,
    r: 3.00055,
    transform: "matrix(-1 0 0 1 81.7422 26.1865)",
    fill: "white",
    stroke: "#0073CB",
    strokeWidth: 2.72777
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.81888,
    cy: 3.81888,
    r: 2.455,
    transform: "matrix(-1 0 0 1 74.1042 34.9155)",
    fill: "white",
    stroke: "#0073CB",
    strokeWidth: 2.72777
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 3.81888,
    cy: 3.81888,
    r: 2.455,
    transform: "matrix(-1 0 0 1 74.1042 18.5488)",
    fill: "white",
    stroke: "#0073CB",
    strokeWidth: 2.72777
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7377 22.9136H68.6488",
    stroke: "#0073CB",
    strokeWidth: 2.72777
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7377 39.2803L68.6488 39.2803",
    stroke: "#0073CB",
    strokeWidth: 2.72777
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7348 8.81873L59.9199 1.09131V62.1934L54.4644 65.4667L50.1 56.1923L40.1891 47.6201L29.3689 28.7812L41.7348 8.81873Z",
    fill: "#F87609"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-18-inside-1_96_1120",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.883 56.8597C70.9576 56.7994 71.04 56.7493 71.1275 56.7101C81.4608 52.0781 88.6588 41.7021 88.6588 29.645C88.6588 13.2725 75.3863 0 59.0139 0C42.6414 0 29.3689 13.2725 29.3689 29.645C29.3689 42.9192 38.0934 54.1556 50.121 57.933C50.5902 58.0803 50.9166 58.5125 50.9121 59.0042L50.8049 70.7926C50.7965 71.7146 51.8647 72.2307 52.5818 71.6511L70.883 56.8597Z"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8049 70.7926L55.1692 70.8323L50.8049 70.7926ZM52.5818 71.6511L49.8384 68.2567L52.5818 71.6511ZM50.121 57.933L48.8133 62.0969L50.121 57.933ZM50.9121 59.0042L46.5479 58.9646L50.9121 59.0042ZM71.1275 56.7101L69.3422 52.7275L71.1275 56.7101ZM70.883 56.8597L73.6264 60.2541L70.883 56.8597ZM84.2944 29.645C84.2944 39.9203 78.1637 48.7731 69.3422 52.7275L72.9127 60.6927C84.7579 55.383 93.0233 43.4839 93.0233 29.645H84.2944ZM59.0139 4.36444C72.9759 4.36444 84.2944 15.6829 84.2944 29.645H93.0233C93.0233 10.8621 77.7967 -4.36444 59.0139 -4.36444V4.36444ZM33.7333 29.645C33.7333 15.6829 45.0518 4.36444 59.0139 4.36444V-4.36444C40.231 -4.36444 25.0045 10.8621 25.0045 29.645H33.7333ZM51.4287 53.7691C41.1679 50.5466 33.7333 40.9583 33.7333 29.645H25.0045C25.0045 44.88 35.0189 57.7647 48.8133 62.0969L51.4287 53.7691ZM55.1692 70.8323L55.2764 59.0439L46.5479 58.9646L46.4407 70.7529L55.1692 70.8323ZM68.1396 53.4653L49.8384 68.2567L55.3253 75.0455L73.6264 60.2541L68.1396 53.4653ZM46.4407 70.7529C46.3987 75.363 51.7396 77.9435 55.3253 75.0455L49.8384 68.2567C51.9898 66.5179 55.1943 68.0662 55.1692 70.8323L46.4407 70.7529ZM48.8133 62.0969C47.5225 61.6915 46.5342 60.4694 46.5479 58.9646L55.2764 59.0439C55.299 56.5555 53.658 54.4692 51.4287 53.7691L48.8133 62.0969ZM69.3422 52.7275C68.9219 52.9159 68.5157 53.1613 68.1396 53.4653L73.6264 60.2541C73.3994 60.4375 73.1581 60.5827 72.9127 60.6927L69.3422 52.7275Z",
    fill: "#0073CB",
    mask: "url(#path-18-inside-1_96_1120)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.4634,
    cy: 30.0055,
    r: 5.45554,
    fill: "black",
    stroke: "#0073CB",
    strokeWidth: 1.09111
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.4634,
    cy: 30.0056,
    r: 4.36444,
    fill: "#F7F9F9",
    stroke: "#0073CB",
    strokeWidth: 3.27333
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M30.46 30.5518H7.54675",
    stroke: "#0073CB",
    strokeWidth: 2.72777
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9851 37.2661H22.5705L17.1989 41.2948",
    stroke: "#0073CB",
    strokeWidth: 2.72777
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9851 23.8369H22.5705L17.1989 19.8082",
    stroke: "#0073CB",
    strokeWidth: 2.72777
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1844,
    cy: 17.7939,
    r: 4.15461,
    fill: "black",
    stroke: "#0073CB",
    strokeWidth: 1.09111
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1845,
    cy: 17.7937,
    r: 3.7731,
    fill: "#F7F9F9",
    stroke: "#0073CB",
    strokeWidth: 3.27333
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.70028,
    cy: 29.8803,
    r: 4.15461,
    fill: "black",
    stroke: "#0073CB",
    strokeWidth: 1.09111
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 5.70004,
    cy: 29.8801,
    r: 3.7731,
    fill: "#F7F9F9",
    stroke: "#0073CB",
    strokeWidth: 3.27333
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1844,
    cy: 43.309,
    r: 4.15461,
    fill: "black",
    stroke: "#0073CB",
    strokeWidth: 1.09111
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.1845,
    cy: 43.3088,
    r: 3.7731,
    fill: "#F7F9F9",
    stroke: "#0073CB",
    strokeWidth: 3.27333
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5404 30.5518H111.454",
    stroke: "#0073CB",
    strokeWidth: 2.72777
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0156 37.2661H96.4303L101.802 41.2948",
    stroke: "#0073CB",
    strokeWidth: 2.72777
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0156 23.8369H96.4303L101.802 19.8082",
    stroke: "#0073CB",
    strokeWidth: 2.72777
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.70016,
    cy: 4.70016,
    r: 4.15461,
    transform: "matrix(-1 0 0 1 108.516 13.0938)",
    fill: "black",
    stroke: "#0073CB",
    strokeWidth: 1.09111
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.13644,
    cy: 2.13644,
    r: 3.7731,
    transform: "matrix(-1 0 0 1 105.952 15.6572)",
    fill: "#F7F9F9",
    stroke: "#0073CB",
    strokeWidth: 3.27333
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.70016,
    cy: 4.70016,
    r: 4.15461,
    transform: "matrix(-1 0 0 1 118.001 25.1802)",
    fill: "black",
    stroke: "#0073CB",
    strokeWidth: 1.09111
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.13644,
    cy: 2.13644,
    r: 3.7731,
    transform: "matrix(-1 0 0 1 115.437 27.7437)",
    fill: "#F7F9F9",
    stroke: "#0073CB",
    strokeWidth: 3.27333
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.70016,
    cy: 4.70016,
    r: 4.15461,
    transform: "matrix(-1 0 0 1 108.516 38.6089)",
    fill: "black",
    stroke: "#0073CB",
    strokeWidth: 1.09111
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.13644,
    cy: 2.13644,
    r: 3.7731,
    transform: "matrix(-1 0 0 1 105.952 41.1724)",
    fill: "#F7F9F9",
    stroke: "#0073CB",
    strokeWidth: 3.27333
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUplGenieLogo1);
export default __webpack_public_path__ + "static/media/UPL_Genie_logo 1.f754ca4408532e33da0625fe2c76e1be.svg";
export { ForwardRef as ReactComponent };